import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import Form from "../../../forms/components/Form/Form";

export default function ISBNInput({ name = "isbn", ...props }) {
	const { t } = useTranslation();
	const { setValue } = useFormContext();

	return (
		<Form.Input
			name={name}
			label={t("isbn", "ISBN")}
			onChange={(e) => {
				let value = e.target.value;

				if (isNaN(e.target.value)) {
					value = e.target.value.replace(/[^0-9]+/g, "");
				}

				return setValue("isbn", value, { shouldDirty: true });
			}}
			{...props}
		/>
	);
}
